import styled from 'styled-components';
import Img from 'gatsby-image';

import { mediaMax, mediaMin } from 'common/styledMixins';
import { color, breakpoint } from 'common/styledVars';
import { BaseTransparentP, BaseP, HeaderMedium } from 'components/typography';
import { ImageBox as ImageBoxBase } from 'components/pages/Partners/styled';
import { Value } from 'components/pages/Home/Partners/styled';
import { WidthWrapper, RelativeWrapper } from 'components/wrappers';
import { HeaderContainer } from 'components/pages/Integrations/styled';

export const GatsbyImage = styled(Img)``;

export const ImageBox = styled(ImageBoxBase)`
  svg {
    margin-top: 10px;
    height: 100%;
    width: 100%;
  }

  @media ${mediaMax(breakpoint.desktop - 1)} {
    position: inherit;
    max-width: 200px;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const HeaderSection = styled(HeaderContainer)`
  ${BaseTransparentP} {
    max-width: 400px;
  }
`;

export const ResultCard = styled.div`
  height: 347px;
  width: 100%;
  border-radius: 17px;
  background-color: #ffffff;
  box-shadow: 0 23px 100px 0 rgba(230, 237, 239, 0.6);

  padding: 34px 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;

  @media ${mediaMin(breakpoint.desktop)} {
    max-width: 270px;
  }
  @media only screen and (max-width: 1024px) {
    padding-top: 20px;
    padding-bottom: 20px;
    height: auto;
  }
`;

interface CircleProps {
  color: string;
}

export const CircleBox = styled.div<CircleProps>`
  position: relative;
  margin-bottom: auto;
  background-color: ${props => props.color};
  height: 188px;
  width: 188px;
  min-height: 188px;
  min-width: 188px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  span {
    display: none;
  }
`;

export const Property = styled(Value)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const CardsContainer = styled.div`
  width: 100%;
  display: grid;
  align-content: space-around;
  grid-template-columns: 1fr;
  justify-content: space-between;
  margin-bottom: 64px;
  margin-top: 32px;

  @media ${mediaMin(breakpoint.desktop)} {
    grid-template-columns: repeat(4, 1fr);
    margin-top: 100px;
    margin-bottom: 142px;
    & > div:nth-of-type(1) {
      margin-top: 72px;
    }

    & > div:nth-of-type(2) {
      margin-top: 173px;
    }

    & > div:nth-of-type(4) {
      margin-top: 72px;
    }
  }

`;

export const TopTextWrapper = styled(WidthWrapper).attrs({ size: 640 })`
  margin-bottom: 100px;

  ${HeaderMedium} {
    margin-bottom: 49px;
  }

  @media only screen and (max-width: 1024px) {
    ${HeaderMedium} {
      margin-bottom: 20px;
    }

    margin-bottom: 20px;
  }
`;

export const WebsiteLinks = styled.div`
  display: flex;
  flex-direction: column;
  margin: 28px auto 0 35px;

  svg {
    margin-right: 8px;
    path {
      stroke: ${color.green.persian};
    }
  }

  & > a {
    display: flex;
    align-items: center;
  }

  ${BaseTransparentP} {
    margin-bottom: 6px;
  }

  ${BaseP} {
    margin-bottom: 6px;
    color: ${color.black};
  }
`;

export const ImageWrapper = styled(WidthWrapper).attrs({ size: 840 })`
  ${GatsbyImage} {
    width: 100%;
  }
`;

export const ContentWrapper = styled.div`
  ${GatsbyImage} {
    max-width: 600px;
  }

  ${HeaderMedium} {
    margin-top: 100px;
  }

  &:last-of-type {
    margin-bottom: 32px;
  }
  @media ${mediaMin(breakpoint.desktop)} {
    &:last-of-type {
      margin-bottom: 100px;
    }
  }
`;

export const TextSmallWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 32px;

  ${BaseP} {
    margin-bottom: 16px;
  }

  @media ${mediaMin(breakpoint.desktop)} {
    margin-top: 100px;
  }
`;

export const AreasWrapper = styled(WidthWrapper).attrs({ size: 880 })`
  margin: 64px 0;

  @media ${mediaMax(breakpoint.desktop - 1)} {
    margin: 0 0 20px 0;
  }
`;

export const RelativeStudyWrapper = styled(RelativeWrapper)``;
